<template>
  <el-dialog title="Adicionar Item ao Recibo" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="400px" v-loading="loading">
    <el-form ref="form" :rules="validacao" :model="itemRecibo" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Data" prop="dataMovimento">
            <el-date-picker v-model="itemRecibo.dataMovimento" type="date" format="dd/MM/yyyy" value-format="dd/MM/yyyy" v-mask="'##/##/####'" style="width: 100%"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Tipo" prop="tipo">
            <el-select v-model="itemRecibo.tipo" style="width:100%;">
              <el-option v-for="item in tipoItemRecibo" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Categoria" prop="descricaoFixa">
            <el-select v-model="itemRecibo.descricaoFixa" style="width:100%;" value-key="label" placeholder="" clearable>
              <el-option v-for="item in DESCRICAO_ITENS" :key="item.label" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="isVisibleAnoIptu">
        <el-col :span="24">
          <el-form-item label="Ano" prop="anoIptu">
            <el-input v-model="itemRecibo.anoIptu" v-mask="'####'" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Descrição" prop="descricaoLivre">
            <el-input v-model="itemRecibo.descricaoLivre"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Valor" prop="valor">
            <money auto-complete="off" v-model.number="itemRecibo.valor" v-bind="money" class="el-input__inner"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-checkbox v-model="itemRecibo.criarItemOutraParte" v-if="itemRecibo.tipo">{{labelItemOutraParte}}</el-checkbox>

      <el-row :gutter="10" v-if="itemRecibo.criarItemOutraParte">
        <el-col :span="12">
          <el-form-item :label="labelValorItemOutraParte" prop="valorItemOutraParte" style="font-weight: bold;">
            <money auto-complete="off" v-model.number="itemRecibo.valorItemOutraParte" :disabled="mesmoValor" v-bind="money" class="el-input__inner"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label=" ">
            <el-checkbox v-model="mesmoValor">Mesmo Valor</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Repetir pelos próximos" prop="quantidadeMeses">
            <el-input v-model.number="itemRecibo.quantidadeMeses">
              <template slot="append">meses</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Iniciar da parcela" prop="parcelaInicial">
            <el-input v-model.number="itemRecibo.parcelaInicial">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-top:20px;">
        <el-col :span="24">
          <strong>{{ labelQuantidadeRecibosDisponiveis }}</strong>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="gravar" type="primary" size="small" round class="btn-box-shadow">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { mapActions } from 'vuex'
import { TIPO_ITEM_RECIBO } from "../../../util/constantes.js";
import { Money } from "v-money";

export default {
  props: {
    recibo: Object,
    visibility: Boolean,
    categoriaCliente: String,
    recibosDoContrato: Array
  },
  components: {
    Money
  },
  data() {
    return {
      itemRecibo: {
        anoIptu: '',
        quantidadeMeses: 0,
        parcelaInicial: 1
      },
      
      mesmoValor: true,
      valorEquivalente: 0,

      DESCRICAO_ITENS: [
				{label: "", data: ""},
				{label: "Água", data: "Água"},
				{label: "Cartório", data: "Cartório"},
				{label: "Condomínio", data: "Condomínio"},
				{label: "Condomínio Tx. Extra", data: "Condomínio Tx. Extra"},
				{label: "Correios", data: "Correios"},
				{label: "Energia Elétrica", data: "Energia Elétrica"},
				{label: "Gás", data: "Gás"},
				{label: "IPTU", data: "IPTU"},
				{label: "IPTU/Taxa de Lixo", data: "IPTU/Taxa de Lixo"},
				{label: "IRRF", data: "IRRF"},
        {label: "PDG", data: "PDG"},
				{label: "Reforma", data: "REFORMA"},
				{label: "Seguro", data: "Seguro"},
				{label: "Tarifas Bancárias", data: "Tarifas Bancárias"},
				{label: "Taxa de Lixo", data: "Taxa de Lixo"},
				{label: "Taxa de Serviço", data: "Taxa de Serviço"},
        {label: "Taxa de Manutenção", data: "Taxa de Manutenção"},
        {label: "Taxa de Desocupação", data: "Taxa de Desocupação"},
				{label: "Rescisão Contratual", data: "Rescisão Contratual"},
        {label: "Telefone", data: "Telefone"},
				{label: "Outros", data: "Outros"},
        {label: "Valor extra", data: "Valor extra"}
      ],

      descricaoObrigatoria: true,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    isVisibleAnoIptu() {
      return this.itemRecibo.descricaoFixa === 'IPTU'
        || this.itemRecibo.descricaoFixa === 'IPTU/Taxa de Lixo';
    },

    validacao() {
      return {
        dataMovimento: [ { required: true } ],
        tipo: [ { required: true } ],
        descricaoFixa: [ { type: 'string', required: this.descricaoObrigatoria } ],
        descricaoLivre: [ { type: 'string', required: !this.itemRecibo.descricaoFixa } ],
        anoIptu: [ { required: true } ],
        valor: [ { required: true, type: 'number', min: 0.01 } ],
        valorItemOutraParte: [ { required: true, type: 'number', min: 0.01 } ],
        quantidadeMeses: [ { required: true, type: 'number', min: 0 } ],
        parcelaInicial: [ { required: true, type: 'number', min: 1 } ],
        }
    },

    tipoItemRecibo() { return TIPO_ITEM_RECIBO },
    labelItemOutraParte() {
      if(this.itemRecibo.tipo === "DEBITO") {
        if(this.categoriaCliente === "LOCATARIO") {
          return "Criar crédito para o proprietário";
        } else if(this.categoriaCliente === "PROPRIETARIO") {
          return "Criar crédito para o locatário";
        } 
      } else if(this.itemRecibo.tipo === "CREDITO") {
        if(this.categoriaCliente === "LOCATARIO") {
          return "Criar débito para o proprietário";
        } else if(this.categoriaCliente === "PROPRIETARIO") {
          return "Criar débito para o locatário";
        } 
      } 
      return ""
    },
    labelValorItemOutraParte() {
      if(this.itemRecibo.criarItemOutraParte) {
        if(this.itemRecibo.tipo === "DEBITO") {
          if(this.categoriaCliente === "LOCATARIO") {
            return "Valor do crédito para o proprietário";		
          } else if(this.categoriaCliente === "PROPRIETARIO") {
            return  "Valor do crédito para o locatário";
          } 
        } else if(this.itemRecibo.tipo === "CREDITO") {
          if(this.categoriaCliente === "LOCATARIO") {
            return  "Valor do débito para o proprietário";
          } else if(this.categoriaCliente === "PROPRIETARIO") {
            return  "Valor do débito para o locatário";
          } 
        }
      } 
      return ""
    },
    labelQuantidadeRecibosDisponiveis() {
      let quantidade = 0;
      this.recibosDoContrato.forEach(item => {
        if(item.status == "EM_ABERTO" && item.mesSerie > this.recibo.mesSerie) {
          quantidade++;
        }
      });
      
      if(quantidade == 0) {
        return "Nenhum recibo disponível ";
      } else if(quantidade == 1) {
        return "1 recibo disponível ";
      } else {
        return quantidade + " recibos disponíveis ";	
      }
    },
    descricaoItem() {
      return this.itemRecibo.descricaoFixa.concat(this.itemRecibo.descricaoLivre ? ' - ' + this.itemRecibo.descricaoLivre : '')
    },
    loading() {
      return this.$store.state.loading;
    }
  },
  watch: {
    mesmoValor() {
      if(this.mesmoValor) {
        this.itemRecibo.valorItemOutraParte = this.itemRecibo.valor
      }
    },
    'itemRecibo.valor': function(){
      if(this.mesmoValor) {
        this.itemRecibo.valorItemOutraParte = this.itemRecibo.valor
      }
    },
    'itemRecibo.descricaoFixa'(newValue){
      if(!newValue || newValue === ''){
        this.descricaoObrigatoria = true
      } else {
        this.descricaoObrigatoria = false
      }
    },
    'itemRecibo.descricaoLivre'(newValue){
      if(!newValue || newValue === ''){
        this.descricaoObrigatoria = true
      } else {
        this.descricaoObrigatoria = false
      }
    }
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('alugueisClientesStore', [
        'gravarItemRecibo'
    ]),

    gravar() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.showLoading();
          this.gravarItemRecibo(this.prepararParametros())
          .then((resultado) => {
              this.hideLoading();
              switch(resultado.status) {
                  case "SUCESSO":
                      this.$message.success(resultado.mensagem);
                      this.fecharSucesso(resultado.lista);
                      break;
                  case "FALHA":
                      this.$message.warning(resultado.mensagem);
                      break;
                  default:
                      this.$message.error(resultado.mensagem);
                      break;
              }
          }).catch(() => {
              this.hideLoading();
          });
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },
    prepararParametros() {
      let payload;

      if(this.itemRecibo.descricaoFixa && this.itemRecibo.descricaoFixa != '' && this.itemRecibo.descricaoLivre && this.itemRecibo.descricaoLivre !== '') {
        payload = {
          ...this.itemRecibo,
          nome: this.descricaoItem
        }
      } else if (this.itemRecibo.descricaoFixa && this.itemRecibo.descricaoFixa != '') {
        payload = {
          ...this.itemRecibo,
          nome: this.itemRecibo.descricaoFixa
        }
      } else {
        payload = {
          ...this.itemRecibo,
          nome: this.itemRecibo.descricaoLivre
        }
      }

      if(this.itemRecibo.descricaoFixa === 'IRRF') {
        payload.categoria = 'IRRF'
      } else if(this.itemRecibo.descricaoFixa === 'IPTU' || this.itemRecibo.descricaoFixa === 'IPTU/Taxa de Lixo') {
        payload.categoria = 'IPTU'
      } else if(this.itemRecibo.descricaoFixa === 'REFORMA') {
        payload.categoria = 'REFORMA'
      } else if(this.itemRecibo.descricaoFixa === 'ITEM_PDG'){
        payload.categoria = 'ITEM_PDG'
      }else if(this.itemRecibo.descricaoFixa === 'Valor extra'){
        payload.categoria = 'VALOR_EXTRA'
      }else if(this.itemRecibo.descricaoFixa === 'Taxa de Manutenção'){
        payload.categoria = 'TAXA_MANUTENCAO'
      }else if(this.itemRecibo.descricaoFixa === 'Taxa de Desocupação'){
        payload.categoria = 'TAXA_DESOCUPACAO'
      }else if(this.itemRecibo.descricaoFixa === 'Rescisão Contratual'){
        payload.categoria = 'RESCISAO_CONTRATUAL'
      }else {
        payload.categoria = 'OUTROS'
      }

      payload.recibo = { id: this.recibo.id }

      delete payload.descricaoFixa;
      delete payload.descricaoLivre;

      return payload;
    },
    // HELPER FUNCTIONS
    exibirAlert(titulo, mensagem) {
        this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    reset(){
      this.itemRecibo = {
        anoIptu: '',
        quantidadeMeses: 0,
        parcelaInicial: 1
      }
      
      this.mesmoValor = true
      this.valorEquivalente = 0
    },
    fecharSucesso(listaRecibos) {
      this.reset()
      this.$emit('close',listaRecibos);
    }, 
    fechar() {
      this.reset()
      this.$emit('close');
    }, 
  }
}
</script>
